interface AcceptInventoryTransferContext {
  status: string;
  destinationLocationId: number | null;
  canApprove: boolean;
  canAccessAllLocations: boolean;
  userPrimaryLocationId?: number | null;
}

/**
 * Mirrors backend canActAtDestinationLocation + pending status for accept UI.
 * Accept is destination-only unless the user has global location access
 * (admin / canSellFromOtherLocations).
 */
export function canAcceptInventoryTransfer({
  status,
  destinationLocationId,
  canApprove,
  canAccessAllLocations,
  userPrimaryLocationId,
}: AcceptInventoryTransferContext): boolean {
  if (status !== 'Pendiente' || !canApprove) {
    return false;
  }
  if (canAccessAllLocations) {
    return true;
  }
  if (destinationLocationId == null || destinationLocationId <= 0) {
    return false;
  }
  return userPrimaryLocationId === destinationLocationId;
}
